module.exports = {
  taxonomy: require('./src/taxonomy'),
  promise: require('./src/promise'),
  genetree: require('./src/genetree'),
  extensions: require('./src/treemodelExtensions')
};



//////////////////
// WEBPACK FOOTER
// ./~/gramene-trees-client/index.js
// module id = 181
// module chunks = 0